import { render, staticRenderFns } from "./PromoBanner.vue?vue&type=template&id=4c905a0b"
import script from "./PromoBanner.vue?vue&type=script&lang=js"
export * from "./PromoBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports